import {
  Box,
  Button,
  Paper,
  Typography,
  Grid,
  Divider,
  CircularProgress,
  Tooltip,
  TextField,
  FormHelperText,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  IconButton,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ClearIcon from "@mui/icons-material/Clear";
import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../Context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import ReferralNavtabs from "./ReferralNavtabs";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ReferralsKyc = () => {
  const { token } = useAuth();
  const apiUrl = process.env.REACT_APP_API_REST_URL;
  const roleId = sessionStorage.getItem("roleId");
  const userId = sessionStorage.getItem("userId");
  const navigate = useNavigate();
  const location = useLocation();
  const leadId = location.state?.leadId;
  const from = location.state?.from || "/employeedashboard/referrals";
  const [annualincometypes, setannualincometypes] = useState([]);
  const [leadData, setLeadData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [occupationtypes, setoccupationtypes] = useState("");
  const [statenames, setstatenames] = useState("");
  const hasFetchedRef = useRef(false);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm();
  // console.log(leadData, "leadDatasda");
  const handleMenuClick = (action) => {
    // Handle different actions based on which menu item was clicked
    switch (action) {
      case "profile":
        navigate("/employeedashboard/referrals/edit", {
          state: { leadId, from },
        });
        break;
      case "add-interaction":
        navigate("/employeedashboard/referrals/add-interaction", {
          state: { leadId, from },
        });
        break;
      case "kyc":
        console.log("View KYC clicked");
        break;
      default:
        break;
    }
  };
  const getAnnualincomeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/estimated_annual_income`;
      const response = await axios.get(url, {});
      console.log("waelthndata", response);
      setannualincometypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getOccupationData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/commonEngine/professions`;
      const response = await axios.get(url, {});
      const sortedOccupations = response.data.response.sort((a, b) =>
        a.profession_name.localeCompare(b.profession_name)
      );
      setoccupationtypes(sortedOccupations);
    } catch (e) {
      console.log(e);
    }
  };
  const getStatesData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/commonEngine/state`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setstatenames(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getAnnualincomeData();
    getOccupationData();
    getStatesData();
  }, []);
  useEffect(() => {
    if (
      !leadId ||
      annualincometypes.length === 0 ||
      occupationtypes.length === 0 ||
      statenames.length === 0
    ) {
      return;
    }

    const fetchLeadData = async () => {
      if (hasFetchedRef.current) return;
      hasFetchedRef.current = true;

      try {
        setIsLoading(true);
        const response = await axios.get(
          `${apiUrl}/CCE/api/v1/referalEngine/getReferralById/${leadId}`
        );
        setLeadData(response.data);

        if (response.data) {
          const formattedData = {
            ...response.data,
            dobOfInvestor: response.data.dobOfInvestor
              ? response.data.dobOfInvestor.split("T")[0]
              : "",
            nomineeDob: response.data.nomineeDob
              ? response.data.nomineeDob.split("T")[0]
              : "",
            pincode: response.data.kycPincode || "",
          };

          reset(formattedData);

          const matchedType = annualincometypes.find(
            (type) =>
              type.masterValueDesc === response.data.investorsIncomeRange
          );

          if (matchedType) {
            setValue("investorsIncomeRange", matchedType.id);
          }

          const matchedOccupation = occupationtypes.find(
            (type) => type.profession_name === response.data.occupation
          );

          if (matchedOccupation) {
            setValue("occupation", matchedOccupation.id);
          }
          const matchedState = statenames.find(
            (type) => type.statename === response.data.kycState
          );

          if (matchedState) {
            setValue("kycState", matchedState.id);
          }
        }
      } catch (err) {
        console.error("Error fetching lead data:", err);
        setError("Failed to load lead data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeadData();
  }, [
    leadId,
    apiUrl,
    reset,
    setValue,
    annualincometypes,
    occupationtypes,
    statenames,
  ]);

  const formatDate = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    } else {
      return "-";
    }
  };

  // const handleAnnualIncomeChange = (event) => {
  //   setselectedannualincometypes(event.target.value);
  // };
  const formatDateforPayload = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = async (data) => {
    // setIsLoading(true);
    try {
      const selectedIncomeType = annualincometypes.find(
        (type) => type.id === data.investorsIncomeRange
      );
      const selectedOcuppationType = occupationtypes.find(
        (type) => type.id === data.occupation
      );
      const selectedState = statenames.find(
        (type) => type.id === data.kycState
      );
      const payload = {
        nameAsPerPan: data.nameAsPerPan,
        dobOfInvestor: formatDateforPayload(data.dobOfInvestor),
        placeOfBirth: data.placeOfBirth,
        postalAddress1: data.postalAddress1,
        postalAddress2: data.postalAddress2,
        nomineeName: data.nomineeName,
        nomineeDob: formatDateforPayload(data.nomineeDob),
        nomineeRelationWithInvestor: data.nomineeRelationWithInvestor,
        occupation: selectedOcuppationType?.profession_name || "",
        investorsIncomeRange: selectedIncomeType?.masterValueDesc || "",
        sourceOfIncome: data.sourceOfIncome,
        city: data.kycCity,
        state: selectedState?.statename || "",
        pincode: data.pincode,
        panNumber: data.panNumber,
        cancelledCheckImg: data.cancelledCheckImg,
        panImg: data.panImg,
        ckycNumber: data.ckycNumber,
        clientId: leadId,
      };

      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/referalEngine/addKycDetails`,
        { ...payload, updated_by: parseInt(userId) },
        { headers: { "x-access-token": token } }
      );
      if (response.data.statusMessage === "Success") {
        toast.success("KYC details updated successfully");
        const updatedDataResponse = await axios.get(
          `${apiUrl}/CCE/api/v1/referalEngine/getReferralById/${leadId}`
        );
        setLeadData(updatedDataResponse.data);
        setEditMode(false);
      } else {
        toast.error("Failed to update KYC details");
      }
      // setLeadData(response.data);

      // console.log("KYC data updated successfully");
    } catch (error) {
      console.error("Error updating KYC data:", error);
      toast.error("An error occurred while updating KYC details");
    }
  };

  const handleCancel = () => {
    // Reset form to original values
    reset(leadData);
    // Exit edit mode
    setEditMode(false);
  };

  return (
    <Box sx={{ ...styles.main_container, height: editMode ? "107vh" : "90vh" }}>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        toastStyle={{ textAlign: "left" }}
        theme="colored"
      />
      <Paper sx={styles.dashboard_paper}>
        <ReferralNavtabs
          handleMenuClick={handleMenuClick}
          options={[
            {
              label: "Edit Profile",
              onClick: () => handleMenuClick("profile"),
            },

            {
              label: "Add Interaction",
              onClick: () => handleMenuClick("add-interaction"),
            },
            { label: "View KYC", onClick: () => handleMenuClick("kyc") },
          ]}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            p: 1,
            justifyContent: "flex-end",
            width: "50%",
            marginLeft: "auto",
          }}
        >
          <Button
            sx={styles.btn}
            variant="contained"
            onClick={() =>
              navigate("/employeedashboard/referrals/view", {
                state: { leadId, from },
              })
            }
          >
            Back
          </Button>
        </Box>
      </Paper>
      <Paper
        elevation={3}
        sx={{
          margin: "10px 20px 20px 20px",
          // height: "590px",
          minHeight: editMode ? "730px" : "590px",
          borderRadius: "12px",
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ padding: 2 }}>
            <Typography color="error">{error}</Typography>
          </Box>
        ) : leadData ? (
          <>
            <Box sx={{ mt: 1 }}>
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={12}
                  align={"left"}
                  sx={{
                    marginLeft: editMode ? 2 : 10,
                    marginTop: 3,
                    marginBottom: 1,
                  }}
                >
                  <Typography fontWeight="bold" gutterBottom>
                    KYC Details
                  </Typography>
                  <Typography fontWeight="bold" gutterBottom>
                    {leadData.firstname}{" "}
                    {leadData.middlename ? leadData.middlename + " " : ""}
                    {leadData.lastname}
                    {leadData.kycStatus && (
                      <span
                        style={{
                          color:
                            leadData.kycStatus === "Pending"
                              ? "red"
                              : leadData.kycStatus === "Incomplete"
                              ? "orange"
                              : leadData.kycStatus === "Completed"
                              ? "green"
                              : "black",
                        }}
                      >
                        {" "}
                        ({leadData.kycStatus})
                      </span>
                    )}
                    {!editMode && (
                      <Tooltip title="Edit / Add">
                        <EditIcon
                          sx={{
                            marginLeft: 1,
                            cursor: "pointer",
                            verticalAlign: "middle",
                          }}
                          onClick={() => setEditMode(true)}
                        />
                      </Tooltip>
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            {editMode ? (
              // <form>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} my={1} px={2}>
                  {/* Left Column Fields */}
                  {/* <Grid item xs={12} md={6}> */}
                  {/* <Grid container spacing={2}> */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="Name as per PAN"
                      variant="outlined"
                      {...register("nameAsPerPan", {
                        required: "Name as per PAN is required",
                      })}
                      error={!!errors.nameAsPerPan}
                      helperText={errors.nameAsPerPan?.message}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="Postal address 1"
                      variant="outlined"
                      {...register("postalAddress1", {
                        required: "Address line 1 is required",
                      })}
                      error={!!errors.postalAddress1}
                      helperText={errors.postalAddress1?.message}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="PAN"
                      variant="outlined"
                      inputProps={{ maxLength: 10 }}
                      {...register("panNumber", {
                        required: "PAN is required",
                        pattern: {
                          value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                          message: "Invalid PAN format",
                        },
                      })}
                      onInput={(e) => {
                        e.target.value = e.target.value.toUpperCase();
                      }}
                      error={!!errors.panNumber}
                      helperText={errors.panNumber?.message}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Button
                      variant="contained"
                      component="label"
                      disabled
                      fullWidth
                      startIcon={<CloudUploadIcon />}
                      sx={{
                        background: "#002C51",
                      }}
                    >
                      Upload PAN
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        {...register("panImg")}
                      />
                    </Button>
                    {watch("panImg") && (
                      <Typography variant="caption" sx={{ ml: 1 }}>
                        {watch("panImg")}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="Postal address 2"
                      variant="outlined"
                      {...register("postalAddress2")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="Date of birth"
                      type="date"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      {...register("dobOfInvestor", {
                        // required: "DOB is required",
                      })}
                      //   error={!!errors.dobOfInvestor}
                      //   helperText={errors.dobOfInvestor?.message}
                    />
                  </Grid>
                  <Grid item xs={false} sm={3} />
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="City"
                      variant="outlined"
                      {...register("kycCity", {
                        required: "City is required",
                      })}
                      error={!!errors.kycCity}
                      helperText={errors.kycCity?.message}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="Place of birth"
                      variant="outlined"
                      {...register("placeOfBirth", {
                        // required: "Place of Birth is required",
                      })}
                      //   error={!!errors.placeOfBirth}
                      //   helperText={errors.placeOfBirth?.message}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="State"
                      variant="outlined"
                      {...register("kycState", {
                        required: "State is required",
                      })}
                      error={!!errors.kycState}
                      helperText={errors.kycState?.message}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      size="small"
                      error={!!errors.kycState}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline legend": {
                          fontSize: "0.78em",
                        },
                      }}
                    >
                      <InputLabel sx={{ fontSize: "13px" }}>State</InputLabel>
                      <Select
                        value={watch("kycState") || ""}
                        {...register("kycState", {
                          required: "State is required",
                        })}
                        onChange={(e) => {
                          setValue("kycState", e.target.value);
                          trigger("kycState");
                        }}
                        label="state"
                        sx={{ ...styles.textfield, textAlign: "left" }}
                      >
                        {statenames.map((type) => (
                          <MenuItem
                            key={type.id}
                            value={type.id}
                            sx={styles.menuItem}
                          >
                            {type.statename}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.kycState && (
                        <FormHelperText>
                          {errors.kycState.message}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      size="small"
                      error={!!errors.occupation}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline legend": {
                          fontSize: "0.78em",
                        },
                      }}
                    >
                      <InputLabel sx={{ fontSize: "13px" }}>
                        Occupation
                      </InputLabel>
                      <Select
                        value={watch("occupation") || ""}
                        {...register("occupation", {
                          // required: "Income range is required",
                        })}
                        label="occupation"
                        sx={{ ...styles.textfield, textAlign: "left" }}
                      >
                        {occupationtypes.map((type) => (
                          <MenuItem
                            key={type.id}
                            value={type.id}
                            sx={styles.menuItem}
                          >
                            {type.profession_name}
                          </MenuItem>
                        ))}
                      </Select>
                      {/* {errors.investorsIncomeRange && (
                                                               <FormHelperText>
                                                                 {errors.investorsIncomeRange.message}
                                                               </FormHelperText>
                                                             )} */}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="PIN code"
                      variant="outlined"
                      inputProps={{ maxLength: 6 }}
                      {...register("pincode", {
                        // required: "Pincode is required",
                        pattern: {
                          value: /^[0-9]{6}$/,
                          message: "Invalid PIN code format",
                        },
                        onChange: (e) =>
                          (e.target.value = e.target.value.replace(/\D/g, "")),
                      })}
                      //   error={!!errors.pincode}
                      //   helperText={errors.pincode?.message}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline legend": {
                          fontSize: "0.78em",
                        },
                      }}
                      //   error={!!errors.investorsIncomeRange}
                    >
                      <InputLabel sx={{ fontSize: "13px" }}>
                        Investor's Income Range
                      </InputLabel>
                      <Select
                        value={watch("investorsIncomeRange") || ""}
                        {...register("investorsIncomeRange", {
                          //   required: "Income range is required",
                        })}
                        label="Investor's income range"
                        sx={{ ...styles.textfield, textAlign: "left" }}
                      >
                        {annualincometypes.map((type) => (
                          <MenuItem
                            key={type.id}
                            value={type.id}
                            sx={styles.menuItem}
                          >
                            {type.masterValueDesc}
                          </MenuItem>
                        ))}
                      </Select>
                      {/* {errors.investorsIncomeRange && (
                        <FormHelperText>
                          {errors.investorsIncomeRange.message}
                        </FormHelperText>
                      )} */}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="Nominee name"
                      variant="outlined"
                      {...register("nomineeName")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="Source of income"
                      variant="outlined"
                      {...register("sourceOfIncome")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="Nominee DOB"
                      type="date"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      {...register("nomineeDob")}
                    />
                  </Grid>
                  <Grid item xs={false} sm={3} />
                  <Grid item xs={12} sm={3}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="CKYC number"
                      variant="outlined"
                      inputProps={{
                        maxLength: 14,
                        pattern: "[0-9]*",
                        inputMode: "numeric",
                      }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      {...register("ckycNumber")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Button
                      variant="contained"
                      component="label"
                      disabled
                      fullWidth
                      startIcon={<CloudUploadIcon />}
                      sx={{
                        background: "#002C51",
                      }}
                    >
                      Upload Cancelled Cheque
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        {...register("cancelledCheckImg")}
                      />
                    </Button>
                    {watch("cancelledCheckImg") && (
                      <Typography variant="caption" sx={{ ml: 1 }}>
                        {watch("cancelledCheckImg")}
                      </Typography>
                    )}
                  </Grid>
                  {/* </Grid> */}
                  {/* </Grid> */}

                  {/* Right Column Fields */}
                  {/* <Grid item xs={12} md={6}> */}
                  {/* <Grid container spacing={2}> */}

                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={styles.textfield}
                      fullWidth
                      size="small"
                      label="Nominee relation with investor"
                      variant="outlined"
                      {...register("nomineeRelationWithInvestor")}
                    />
                  </Grid>
                </Grid>
                {/* </Grid> */}
                {/* </Grid> */}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "1rem",
                  }}
                >
                  <Button
                    variant="outlined"
                    sx={{
                      color: "Black",
                      marginRight: "10px",
                      textTransform: "none",
                    }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      padding: "5px 15px",
                      background: "#002C51",
                      color: "#fff",
                      marginLeft: "10px",
                      textTransform: "none",
                      "&:hover": { background: "#002C51" },
                    }}
                  >
                    Update
                  </Button>
                </Box>
              </form>
            ) : (
              <Box sx={{ mt: 1 }}>
                <Grid container spacing={1}>
                  {/* Left Column */}
                  {/* <Grid
                    item
                    xs={12}
                    align={"left"}
                    marginLeft={10}
                    marginTop={3}
                    marginBottom={1}
                  >
                    <Typography fontWeight="bold" gutterBottom>
                      KYC Details
                    </Typography>
                    <Typography fontWeight="bold" gutterBottom>
                      {leadData.firstname}{" "}
                      {leadData.middlename ? leadData.middlename + " " : ""}
                      {leadData.lastname}
                      {leadData.kycStatus && (
                        <span
                          style={{
                            color:
                              leadData.kycStatus === "Pending"
                                ? "red"
                                : leadData.kycStatus === "Incomplete"
                                ? "orange"
                                : leadData.kycStatus === "Completed"
                                ? "green"
                                : "black",
                          }}
                        >
                          {" "}
                          ({leadData.kycStatus})
                        </span>
                      )}
                      <Tooltip title="Edit / Add">
                        <EditIcon
                          sx={{
                            marginLeft: 1,
                            cursor: "pointer",
                            verticalAlign: "middle",
                          }}
                        />
                      </Tooltip>
                    </Typography>
                  </Grid> */}
                  <Grid item xs={12} md={6}>
                    <Grid container spacing={1}>
                      {/* Name */}

                      <Grid item xs={5}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Name as per PAN:
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography
                          sx={styles.viewField}
                          align={"left"}
                          //   marginLeft={10}
                          variant="body2"
                        >
                          {leadData.nameAsPerPan || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          PAN:
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.panNumber || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Date of birth:
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {formatDate(leadData.dobOfInvestor) || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Place of birth:
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.placeOfBirth || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Occupation:
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.occupation || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Investor's income range:
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.investorsIncomeRange || "-"}
                        </Typography>
                      </Grid>
                      {/* 
                  <Grid item xs={12} sx={{ my: 1 }}>
                    <Divider />
                  </Grid> */}

                      <Grid item xs={5}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Source of income:
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.sourceOfIncome || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          CKYC number:
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.ckycNumber || "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={5}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Pan image:
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.panImg || "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Right Column */}
                  <Grid item xs={12} md={6}>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Postal address 1:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          align={"left"}
                          variant="body2"
                        >
                          {leadData.postalAddress1 || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Postal address 2:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.postalAddress2 || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          City:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.kycCity || "-"}
                        </Typography>
                      </Grid>

                      {/* <Grid item xs={12} sx={{ my: 1 }}>
                    <Divider />
                  </Grid> */}

                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          State:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {/* {formatDate(latestInteraction?.meeting_at) || "-"} */}
                          {leadData.kycState || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          PIN code:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.kycPincode || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Nominee name:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.nomineeName || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Nominee DOB:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {formatDate(leadData.nomineeDob) || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                        >
                          Nominee relation with investor:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.nomineeRelationWithInvestor || "-"}
                        </Typography>
                      </Grid>

                      {/* <Grid item xs={12} sx={{ my: 1 }}>
                    <Divider />
                  </Grid> */}
                      <Grid item xs={6}>
                        <Typography
                          variant="body2"
                          fontWeight="bold"
                          align={"left"}
                          marginLeft={10}
                          sx={styles.viewField}
                        >
                          Cancelled cheque image:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          sx={styles.viewField}
                          variant="body2"
                          align={"left"}
                        >
                          {leadData.cancelledCheckImg || "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            )}
          </>
        ) : (
          <Box sx={{ padding: 2 }}>
            <Typography>No kyc data available</Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default ReferralsKyc;
const styles = {
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // height: editMode ? "107vh": "95vh",
    // minHeight: editMode ? "730px" : "590px",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "0px 20px",
  },
  btn: {
    width: "80px",
    fontSize: "11px",
    marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    // width: "340px",
    fontSize: "13px",
    "& .MuiInputBase-input": {
      fontSize: "13px",
    },
    "& .MuiInputLabel-root": {
      fontSize: "13px",
    },
    "& .MuiOutlinedInput-notchedOutline legend": {
      fontSize: "0.6em",
    },
    menuItem: {
      fontSize: "13px",
    },
  },
  viewField: {
    fontSize: "13px",
  },
};
